module.exports = __webpack_public_path__ + "img/N3.60226342.png";